import "./CreateReschedule.css";
import React, { useEffect, useState } from "react";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Type from "./Type/Type";
import Leads from "./Leads/Leads";
import Design from "./Design/Design";
import Send from "./Send/Send";
import uniqid from "uniqid";
import { useLocation, useNavigate } from "react-router-dom";
import storeCampaign from "../Controller/storeCampaign";
import HelperForMetaData from "../../../helpers/HelperForMetaData";
import {
  AuthErrorMessages,
  ToastSuccessMessages,
} from "../../../controllers/auth/AuthErrorMessages";
import getSingleCampaign from "../Controller/getSingleCampaign";
import getSingleProperty from "../Controller/getSingleProperty";
import getAllLeadsInCampaign from "../Controller/getAllLeadsInCampaign";
import getSingleTemplate from "../Controller/getSingleTemplate";
import storeDataToMail from "../Controller/storeDataToMail";
import { db } from "../../../firebase";
import { doc, getDoc } from "firebase/firestore";
import getSettings from "../../../controllers/settings/getSettings";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import FormatPriceVerbal from "../../../helpers/FormatPriceVerbal";
import FormatPriceNumeral from "../../../helpers/FormatPriceNumeral";
import axios from "axios";
const CreateReschedule = () => {
  const date =
    new Date().toLocaleString("en-US", { day: "2-digit" }) +
    "-" +
    new Date().toLocaleString("en-US", { month: "short" }) +
    "-" +
    new Date().getFullYear();
  const steps = ["Type", "Leads", "Design", "Send"];
  const [currentStep, setCurrentStep] = useState(1);
  const [complete, setComplete] = useState(false);
  const [campaignTitle, setCampaignTitle] = useState(
    "Email Marketing Campaign " + date
  );
  const [campaignSource, setCampaignSource] = useState("Email");
  const [campaignType, setCampaignType] = useState("Now");
  const [property, setProperty] = useState(null);
  const [leads, setLeads] = useState([]);
  const [template, setTemplate] = useState(null);
  const [BDetails, setBDetails] = useState({});
  const [user, setUser] = useState({});

  const [templateHtml, setTemplateHtml] = useState("");
  const [isSend, setIsSend] = useState(false);

  const [propertyError, setPropertyError] = useState(false);
  const [leadsError, setLeadsError] = useState(false);
  const [templateError, setTemplateError] = useState(false);
  const [campaignTitleError, setcampaignTitleError] = useState(false);
  const [campaignData, setCampaignData] = useState({});
  const [campaignProperty, setCampaignProperty] = useState("");
  const [campaignId, setCampaignId] = useState("");
  const [mCurrencySettings, setMCurrencySettings] = useState({});
  const [completed, setCompeleted] = useState(0);
  const [statusArray, setStatusArray] = useState([]);

  const [progressMessage, setProgressMessage] = useState(
    "Processing Started...."
  );
  const [isBtnDisable, setBtnDisable] = useState(true);
  const navigate = useNavigate();
  //location
  let location = useLocation();

  useEffect(() => {
    console.log("property property", property);
  }, [property]);
  useEffect(async () => {
    // Values initilization
    if (campaignProperty !== "") {
      let tempProperty = await getSingleProperty(campaignProperty);
      console.log(campaignProperty);
      setProperty({ id: campaignProperty, ...tempProperty });
      setBtnDisable(false);
      setPropertyError(false);
    }
  }, [campaignProperty]);
  useEffect(() => {
    async function fetchData() {
      const clientDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );
      const clientSnapshot = await getDoc(clientDocument);
      const client = { id: clientSnapshot.id, ...clientSnapshot.data() };
      setBDetails(client);
      const usersDocument = await doc(db, "users", client.uid);
      const usersSnapshot = await getDoc(usersDocument);
      const users = { id: usersSnapshot.id, ...usersSnapshot.data() };
      setUser(users);

      const settings = await getSettings();
      setMCurrencySettings(settings);
    }
    fetchData();
  }, []);

  useEffect(() => {
    const locationArr = location.pathname.split("/");

    // If it is update Deal get single deal data

    if (locationArr[4] == "reschedule") {
      const fetchData = async () => {
        let campaign = await getSingleCampaign(locationArr[5]);
        setCampaignId(uniqid() + uniqid() + uniqid());
        setCampaignSource(campaign.campaignSource);
        setCampaignType(campaign.campaignType);
        setCampaignTitle(campaign.campaignTitle);
        setCampaignProperty(campaign.property);

        let tempLeads = await getAllLeadsInCampaign(campaign.leads);
        let tempTemplate = await getSingleTemplate(campaign.template);

        setLeads(tempLeads);
        setTemplate(tempTemplate);
      };
      fetchData();
    } else {
      setCampaignId(uniqid() + uniqid() + uniqid());
      setBtnDisable(false);
    }
  }, []);
  const localValidation = () => {
    if (currentStep === 1) {
      let flag = 0;

      if (property === null) {
        setPropertyError(true);
        flag++;
      } else {
        setPropertyError(false);
      }
      if (campaignTitle.length === 0) {
        setcampaignTitleError(true);
        flag++;
      } else {
        setcampaignTitleError(false);
      }
      if (flag === 0) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 2) {
      if (leads.length === 0) {
        setLeadsError(true);
      } else {
        setLeadsError(false);
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 3) {
      if (template === null) {
        setTemplateError(true);
      } else {
        setTemplateError(false);
        setCurrentStep((prev) => prev + 1);
      }
    }
  };

  useEffect(() => {
    if (property != null && leads.length > 0 && template != null) {
      let leadIds = [];
      for (let i = 0; i < leads.length; i++) {
        leadIds.push(leads[i].id);
      }
      let tempCampaignData = {
        campaignTitle: campaignTitle,
        campaignType: campaignType,
        campaignSource: campaignSource,
        property: property.id,
        leads: leadIds,
        template: template.id,
        campaignId: campaignId,
        statusArray: statusArray,
        templateHtml: templateHtml,
      };
      setCampaignData(tempCampaignData);
    }
  }, [
    campaignSource,
    property,
    campaignTitle,
    campaignType,
    template,
    campaignId,
    statusArray,
    templateHtml,
  ]);

  useEffect(async () => {
    if (isSend === true) {
      const finalCampaignData = HelperForMetaData({ ...campaignData });
      let resp = await storeCampaign(campaignId, finalCampaignData);
      if (resp) {
        setComplete(true);
        ToastSuccessMessages("camp/camp-successful");
      } else {
        AuthErrorMessages("camp/camp-error");
        setBtnDisable(false);
      }
    }
  }, [campaignData, isSend]);
  const sendEmail = async (iStart, iEnd) => {
    let temp = [];
    temp = statusArray;
    const propertyTitle = property.propertyTitle;
    const propertyCity = property?.city;
    // const propertyImage =
    //   property?.images?.length > 0
    //     ? property?.images[0]
    //     : `https://actdwm.stripocdn.email/content/guids/CABINET_a5ab9a577b8b948a7d2025679ccd1afe386319fac48ed8002beb9f53098ca24b/images/architecture5339245__340.jpg`;
    const propertyPrice =
      mCurrencySettings.currency + mCurrencySettings.currencyFormat ===
      "numeral"
        ? property?.rentalPrice > 0
          ? FormatPriceNumeral(property?.rentalPrice)
          : FormatPriceNumeral(property?.sellingPrice)
        : property?.rentalPrice > 0
        ? FormatPriceVerbal(property?.rentalPrice)
        : FormatPriceVerbal(property?.sellingPrice);
    // const businessBDetails = BDetails?.image_url
    //   ? BDetails?.image_url
    //   : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/220px-Image_created_with_a_mobile_phone.png";
    const businessName = BDetails?.businessName;
    const propertyAddress = property?.address;
    for (let i = iStart; i <= iEnd; i++) {
      if (campaignSource === "Email") {
        if (
          leads &&
          leads[i] &&
          leads[i].email != null &&
          leads[i].email != "" &&
          leads[i].email != undefined
        ) {
          let result = await storeDataToMail(
            leads[i].email,
            user.email === "" ? "flutter.logicworms@gmail.com" : user.email,
            BDetails.businessName === "" ? "Landbook" : BDetails.businessName,
            property?.propertyTitle + ", " + property?.propertySubType,
            property?.availableForRent === true ? "Rent" : "Sell",
            templateHtml
          );

          console.log("Temp Array, Result", result);
          if (result === false) {
            temp.push(false);
          } else {
            temp.push(true);
          }

          console.log("Temp Array, ", temp);
        }
      } else {
        if (
          leads &&
          leads[i] &&
          leads[i].phone != null &&
          leads[i].phone != "" &&
          leads[i].phone != undefined
        ) {
          // await sendMessageToWhatsApp(
          //   leads[i].phone,
          //   propertyTitle,
          //   propertyPrice,
          //   propertyCity,
          //   propertyAddress,
          //   propertyDesc,
          //   businessBDetails,
          //   propertyImage,
          //   template.id
          // );

          try {
            const header = {
              headers: {
                Authorization:
                  "Bearer EAAGyOsRZCjaYBAG1yizHcX4zLcSG6YbKVymBUYphc12tZBSQEWhEoVcBPSH3JOwXSymBQuuSh826PvS98nLeEJeKTCAC1jiMfugWf0QLn98nHzMKKSIYa6iZAR5bboVzb2gNVBMPmOIGOXeed6p5yHRZB396JeVgiEwmixxFa3qZCUFS5WAP32wha841o6oLdsQ4iVsxGkQcnVTnBYPZAW",
                Accept: "application/json",
              },
            };
            const body = {
              messaging_product: "whatsapp",
              to: leads[i].phone,
              // message_type: "text",

              type: "template",
              // text: {
              //   body: "Custom Hello World!!!",
              // },
              template: {
                name: "hello_world",
                language: { code: "en_US" },
                components: [
                  {
                    type: "body",
                    parameters: [
                      {
                        type: "text",
                        text: propertyTitle,
                      },
                      {
                        type: "text",
                        text: propertyPrice.toLocaleString(),
                      },
                      {
                        type: "text",
                        text: propertyCity.toLocaleString(),
                      },
                      {
                        type: "text",
                        text: propertyAddress.toLocaleString(),
                      },
                      {
                        type: "text",
                        text: businessName.toLocaleString(),
                      },
                    ],
                  },
                ],
              },
            };

            axios
              .post(
                "https://graph.facebook.com/v15.0/112426465070775/messages",
                body,
                header
              )
              .then((res) => {
                console.log("ex ex ex", res);
              })
              .catch((ex) => {
                console.log("ex ex ex", ex);
              });
          } catch (ex) {
            console.log("ex ex ex", ex);
          }
        }
      }
    }
    console.log("Temp Array, ", temp);
    setStatusArray(temp);
  };

  const storeData = async () => {
    let resp;

    const totalLeads = leads.length;
    const leadsIncrement = totalLeads / 4;
    let iStart = 0;
    let iEnd = leadsIncrement;
    if (totalLeads >= 4) {
      setTimeout(() => {
        setCompeleted(20);
        setProgressMessage("Data stored...");
        setTimeout(async () => {
          await sendEmail(iStart, iEnd);
          setCompeleted(40);
          setProgressMessage(
            `Sending ${campaignSource} ${iEnd}/${totalLeads}..`
          );
          iStart = iStart + leadsIncrement;
          iEnd = iEnd + leadsIncrement;
          setTimeout(async () => {
            await sendEmail(iStart, iEnd);
            setCompeleted(60);

            setProgressMessage(
              `Sending ${campaignSource} ${iEnd}/${totalLeads}..`
            );
            iStart = iStart + leadsIncrement;
            iEnd = iEnd + leadsIncrement;
            setTimeout(async () => {
              await sendEmail(iStart, iEnd);
              setCompeleted(80);

              setProgressMessage(
                `Sending ${campaignSource} ${iEnd}/${totalLeads}..`
              );
              iStart = iStart + leadsIncrement;
              iEnd = iEnd + leadsIncrement;
              setTimeout(async () => {
                await sendEmail(iStart, iEnd);
                setIsSend(true);
                setCompeleted(100);
                setProgressMessage(
                  `Sending ${campaignSource} ${iEnd}/${totalLeads}..`
                );

                setTimeout(() => {
                  navigate("/user/marketing");
                }, 2000);
              }, 2000);
            }, 2000);
          }, 2000);
        }, 2000);
      }, 2000);
    } else {
      setTimeout(async () => {
        await sendEmail(0, leads.length);
        setIsSend(true);

        setCompeleted(100);

        setProgressMessage(`Sending ${campaignSource}........`);
        setTimeout(() => {
          navigate("/user/marketing");
        }, 2000);
      }, 2000);
    }
  };
  return isBtnDisable ? (
    <div className="interstitial-loader">
      <div className="sk-three-bounce">
        <div className="sk-child sk-bounce1"></div>
        <div className="sk-child sk-bounce2"></div>
        <div className="sk-child sk-bounce3"></div>
      </div>
    </div>
  ) : (
    <div className="global-body-container marketing-create">
      {/* Stepper */}

      <h1 className="marketing-page-title">Create Campaign</h1>
      <div className="stepper-root">
        {steps?.map((step, i) => (
          <div
            key={i}
            className={`step-item ${currentStep === i + 1 && "active"} ${
              (i + 1 < currentStep || complete) && "complete"
            } `}
          >
            <div key={i} className="step-item2">
              <div className="step">
                {i + 1 < currentStep || complete ? (
                  <DoneRoundedIcon size={24} className="create-check-icon" />
                ) : (
                  i + 1
                )}
              </div>
              {i + 1 < currentStep ? (
                <div className="bt bt-active"></div>
              ) : (
                i < steps.length - 1 && <div className="bt"></div>
              )}
            </div>
            <p className="text-gray-500">{step}</p>
          </div>
        ))}
      </div>
      {/* Stepper End */}

      {/* Forms will be render here based on some condition */}

      <div className="marketing-form-container">
        {currentStep === 1 ? (
          <Type
            campaignTitle={campaignTitle}
            setCampaignTitle={setCampaignTitle}
            campaignSource={campaignSource}
            setCampaignSource={setCampaignSource}
            campaignType={campaignType}
            setCampaignType={setCampaignType}
            property={property}
            setProperty={setProperty}
            propertyError={propertyError}
            setPropertyError={setPropertyError}
            campaignTitleError={campaignTitleError}
            setcampaignTitleError={setcampaignTitleError}
            date={date}
          />
        ) : currentStep === 2 ? (
          <Leads
            leads={leads}
            setLeads={setLeads}
            leadsError={leadsError}
            setLeadsError={setLeadsError}
            campaignSource={campaignSource}
          />
        ) : currentStep === 3 ? (
          <Design
            template={template}
            setTemplate={setTemplate}
            property={property}
            templateError={templateError}
            setTemplateError={setTemplateError}
            getCampaignSource={campaignSource}
            setTemplateHtml={setTemplateHtml}
            templateHtml={templateHtml}
          />
        ) : (
          <Send
            campaignTitle={campaignTitle}
            campaignSource={campaignSource}
            campaignType={campaignType}
            property={property}
            leads={leads}
            template={template}
            complete={complete}
            completed={completed}
            progressMessage={progressMessage}
            templateHtml={templateHtml}
          />
        )}
      </div>
      {/* Forms End */}

      {/* Next & Back Buttons */}
      {!complete && (
        <div className="marketing-bottom-btn-container">
          {currentStep !== 1 ? (
            <button
              className="marketing-back-btn-class"
              onClick={() => {
                setCurrentStep((prev) => prev - 1);
              }}
              disabled={isBtnDisable}
            >
              <ArrowBackIosIcon
                sx={{
                  fontSize: "20px",
                }}
              />{" "}
              Back
            </button>
          ) : (
            <div></div>
          )}
          <button
            className="marketing-btn-class"
            onClick={() => {
              currentStep === steps.length ? storeData() : localValidation();
            }}
            disabled={isBtnDisable}
          >
            {currentStep === steps.length ? "Send " : "Next "}

            <ArrowForwardIosIcon
              sx={{
                fontSize: "20px",
              }}
            />
          </button>
        </div>
      )}

      {/* Next and Back Buttons End */}
    </div>
  );
};

export default CreateReschedule;
